<template>
  <BarChart :chartData="chartDatasets" :options="chartOptions" :height="chartHeight" :width="chartWidth" />
</template>

<script>
import { BarChart } from 'vue-chart-3';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(...registerables, ChartDataLabels);

export default {
  name: 'NewBuildingPrices',
  components: { BarChart },
  props: {
    dataSet: {
      type: Object,
      default() {
        return {};
      }
    },
    maxData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      chartDatasets: {
        labels: [],
        datasets: [{
          footer: '123123',
          label: 'Data1',
          data: [],
          quantity_dynamics: [],
          stack: 'Stack 0',
          backgroundColor: '#82bf00',
          // borderWidth: {
          //     top: 4
          // },
          // BarThickness: 52,
          barPercentage: 0.8,
          // categoryPercentage: 0.1,
          // maxBarThickness: 52,
          borderColor: 'transparent',
          borderRadius: {
            topLeft: 2,
            topRight: 2,
          },
          dataAll: [],
          borderSkipped: false,
          datalabels: {

            color: 'transparent',
            labels: {
              value: {
                // color: 'white'
              }
            }
          }
        },
          {
            footer: '123123',
            label: 'Data1',
            data: [],
            dataAll: [],
            quantity_dynamics: [],
            stack: 'Stack 1',
            backgroundColor: '#9ac2ff',
            // borderWidth: {
            //     top: 4
            // },
            // BarThickness: 52,
            barPercentage: 0.8,
            // categoryPercentage: 0.1,
            // maxBarThickness: 52,
            borderColor: 'transparent',
            borderRadius: {
              topLeft: 2,
              topRight: 2,
            },
            borderSkipped: false,
            datalabels: {

              color: 'transparent',
              labels: {
                value: {
                  // color: 'white'
                }
              }
            }
          }]
      },
      chartOptions: {
        animations: false,
        onHover: (event, chartElement) => {
          event.native.target.style.cursor = 'pointer'
        },
        plugins: {
          tooltip: {
            enabled: false,
            external: function (context) {
              let tooltipEl = document.getElementById('chartjs-tooltip1');
              // if (document.documentElement.clientWidth >= 650) {
              //     tooltipEl = document.getElementById('chartjs-tooltip1')
              // } else {
              //     tooltipEl = document.getElementById('chartjs-tooltip')
              // }

              const tooltipModel = context.tooltip;
              if (tooltipModel.opacity === 0) {
                closePopup();
                return;
              }

              // цвет текста в зависимости от значения
              function getColor(val) {
                if (Number(val) > 0) {
                  return 'color:#699b12;';
                } else if (Number(val) < 0) {
                  return 'color:#6D6D6D;';
                } else return 'color:#6D6D6D;';
              }


              tooltipEl.style.opacity = 1
              tooltipEl.style.visibility = 'visible'
              const position = context.chart.canvas.getBoundingClientRect()

              // Добавляем обработчик события для отслеживания перемещения указателя мыши
              if(document.documentElement.clientWidth >= 650) {
                tooltipEl.style.position = 'absolute'
                if (tooltipModel.caretX > tooltipEl.offsetWidth ? tooltipEl.offsetWidth : 0) {
                  tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX - tooltipEl.offsetWidth + 'px'
                } else {
                  tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px'
                }
                tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px'
                tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
                tooltipEl.style.pointerEvents = 'none'
              } else {
                tooltipEl.style.position = 'fixed'
                tooltipEl.style.left = 0
                tooltipEl.style.top = 0
                tooltipEl.style.padding = tooltipModel.padding + 'px ' + tooltipModel.padding + 'px'
              }


              function closePopup() {
                tooltipEl.style.opacity = 0;
                tooltipEl.style.visibility = 'hidden';
                tooltipEl.style.removeProperty('width');
                tooltipEl.style.removeProperty('bottom');
                document.body.classList.remove('body-lock-scroll');
                document.removeEventListener('click', closePopup);
                document.removeEventListener('scroll', hideOnscroll);
              }

              function hideOnscroll() {
                closePopup();
                if (document.documentElement.clientWidth >= 650) {
                  let innerWidth = window.innerWidth;
                  let documentWidth = document.documentElement.clientWidth
                  if (innerWidth === documentWidth) {
                  }
                }
              }

              if (tooltipModel.body) {
                let innerHtml
                let title = tooltipModel.title[0].split(',').join(' ')
                //console.log(tooltipModel._tooltipItems[0])
                //console.log(tooltipModel.dataPoints[0].dataset.quantity_dynamics[tooltipModel.dataPoints[0].dataIndex])
                let quantity = tooltipModel._tooltipItems[0]?.raw
                let name = tooltipModel.dataPoints[0].dataset.label;
                function changeAbs(val){
                  if (parseFloat(val) > 0){
                    return '+'+val
                  }
                  return val
                }
                //console.log(tooltipModel.dataPoints[0].dataset.dataAll[tooltipModel.dataPoints[0].dataIndex])
                let quantity_dynamic = String(changeAbs(tooltipModel.dataPoints[0].dataset.dataAll[tooltipModel.dataPoints[0].dataIndex][0])).split('.').join(',')
                let quantity_year = String(changeAbs(tooltipModel.dataPoints[0].dataset.dataAll[tooltipModel.dataPoints[0].dataIndex][1])).split('.').join(',')
                if (document.documentElement.clientWidth >= 650) {
                  innerHtml = '<p class="bar" style="border-radius: 4px; font-family: Gilroy-Medium, sans-serif;width: max-content; background: ' + tooltipModel.labelColors[0].backgroundColor + '; padding: 1px 6px; margin-bottom: 8px; font-size: 12px; line-height: 16px">' + title + '</p>'  + '<div style="margin-bottom: 8px ; display: flex; justify-content: space-between; align-items: flex-start"><p style="color:#252628;font-family: Gilroy-Medium, sans-serif; font-size: 12px; line-height: 16px;max-width: 165px;  font-size: 12px; line-height: 16px;">' +
                      'Реальные цены'
                      + `</p> <p style="max-width: 117px; font-family: Gilroy-Semibold, sans-serif;  font-size: 14px; line-height: 20px; color: #252628;" >${quantity_dynamic}%</p>` +`</div>`+  '<div style="display: flex; justify-content: space-between; align-items: flex-start"><p style="color:#252628;font-family: Gilroy-Medium, sans-serif; font-size: 12px; line-height: 16px;max-width: 165px;  font-size: 12px; line-height: 16px;">' +
                      'Номинальные цены'
                      + `</p> <p style="max-width: 117px; font-family: Gilroy-Semibold, sans-serif;  font-size: 14px; line-height: 20px; color:#252628; " >${quantity_year}%</p>`
                  tooltipEl.innerHTML = innerHtml
                }
                else {
                  innerHtml = '<div class="chartjs-popup"><div class="chartjs-popup-title" ><button class="chartjs-popup__button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">\n' +
                      '<rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#252628"/>\n' +
                      '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.2092 11.2092C11.4882 10.9303 11.9404 10.9303 12.2194 11.2092L16 14.9898L19.7806 11.2092C20.0596 10.9303 20.5118 10.9303 20.7908 11.2092C21.0697 11.4882 21.0697 11.9404 20.7908 12.2194L17.0102 16L20.7908 19.7806C21.0697 20.0596 21.0697 20.5118 20.7908 20.7908C20.5118 21.0697 20.0596 21.0697 19.7806 20.7908L16 17.0102L12.2194 20.7908C11.9404 21.0697 11.4882 21.0697 11.2092 20.7908C10.9303 20.5118 10.9303 20.0596 11.2092 19.7806L14.9898 16L11.2092 12.2194C10.9303 11.9404 10.9303 11.4882 11.2092 11.2092Z" fill="#252628"/>\n' +
                      '</svg></button></div>' + '<p class="bar" style="border-radius: 4px; width: max-content; background: ' + tooltipModel.labelColors[0].backgroundColor + '; padding: 1px 6px; margin-bottom: 23px;margin-top:7px; font-size: 12px; line-height: 16px">' + title + '</p>' + '<div style="margin-bottom: 8px; display: flex; justify-content: space-between"><p class="chartjs-popup-mobile-close-diff" style="color:#252628;font-size: 12px; line-height: 16px;">' +
                      'Реальные цены'
                      + `</p> <p class="chartjs-popup-mobile-close-value-dynamic" style=" font-family: Gilroy-Semibold, sans-serif;  font-size: 16px; line-height: 24px; color:#252628;" >${quantity_dynamic}%</p></div>` +
                      '<div style="display: flex; justify-content: space-between"><p class="chartjs-popup-mobile-close-diff" style="color:#252628; font-family: Gilroy-Medium, sans-serif; font-size: 12px; line-height: 16px;">' +
                      'Номинальные цены'
                      + `</p> <p class="chartjs-popup-mobile-close-value-dynamic" style="font-family: Gilroy-Semibold, sans-serif;  font-size: 16px; line-height: 24px; color:#252628;" >${quantity_year}%</p></div>`
                  tooltipEl.innerHTML = innerHtml
                  document.querySelector('.chartjs-popup__button').addEventListener('click', closePopup)
                }
              }

              document.addEventListener('scroll', hideOnscroll);

              if (document.documentElement.clientWidth <= 649) {
                document.body.classList.add('body-lock-scroll');
              }
            }
          },
          legend: false,
          datalabels: {
            labels: {
              value: {
                anchor: 'center',
                align: 'center',
                formatter: (value, context) => {
                  //console.log(context.dataset.topics[context.dataIndex].quantity_percent)
                  // if (context.dataset.topics[context.dataIndex].quantity_percent > 10) {
                  //     return context.dataset.topics[context.dataIndex].quantity_percent + '%'
                  // }
                  // return ''
                }
              },
              title: {
                formatter: (value, context) => {
                  return '' //value > 0 ? '+'+String(value).split('.').join(','): String(value).split('.').join(',')
                },
                anchor: 'end',
                color: '#252628',
                align: 'end',
                font: {
                  size: document.documentElement.clientWidth >= 768 ? 16 : 14,
                  family: 'Gilroy-SemiBold'
                }
              }
            }
          },
        },
        responsive: () => {
          return this.isMobile();
        },
        scales: {
          x: {
            grid: {
              display: false,
              borderColor: '#999999',
            },
            ticks: {
              color: '#999999',
              font: {
                size: 12
              },
              padding: 2,
              callback: (idx) => {
                if (this.chartDatasets.labels[idx].includes(' ')) {
                  let splitArr = this.chartDatasets.labels[idx].split(' ');
                  let number = [splitArr[0] + ' ' + splitArr[1], splitArr[2]];
                  return number;
                } else return this.chartDatasets.labels[idx]
              }
            },
          },
          y: {
            grid: {
              drawBorder: true,
              drawTicks: true,
              display: false,
              borderColor: '#999999'
            },
            title: {
              display: false
            },
            max: Math.max.apply(null, this.maxData),
            ticks: {
              color: '#999999',
              // backdropPadding: 10,
              font: {
                size: 12
              },
              align: 'end',
              callback(val, index, ticks) {
                const maxCount = Math.max.apply(null, ticks.map((a) => a.value))
                if (val === maxCount) {
                  return document.documentElement.clientWidth >= 767 ? ['%', 'за период', ' '] : ['%', 'за', 'период', ' ']
                } else {
                  return val
                }
              },
            }
          }
        }
      }
    };
  },
  mounted() {
    let periods;
    if (document.documentElement.clientWidth <= 649) {
      periods = this.dataSet.slice(2);
    } else {
      periods = this.dataSet;
    }
    periods.forEach((el, idx) => {
      //console.log(el)
      this.chartDatasets.labels[idx] = el.quarter;
      this.chartDatasets.datasets[0].data[idx] = parseFloat(el.real_prices.split(',').join('.'));
      this.chartDatasets.datasets[1].data[idx] = parseFloat(el.nominal_prices.split(',').join('.'));
      this.chartDatasets.datasets[0].dataAll[idx] = [parseFloat(el.real_prices.split(',').join('.')),parseFloat(el.nominal_prices.split(',').join('.'))];
      this.chartDatasets.datasets[1].dataAll[idx] = [parseFloat(el.real_prices.split(',').join('.')),parseFloat(el.nominal_prices.split(',').join('.'))];

    })
    //console.log(this.chartDatasets)
  },
  computed: {
    isDesktop() {
      return document.documentElement.clientWidth >= 1124;
    },
    chartHeight() {
      return (this.isDesktop) ? 586 : 586;
    },
    chartWidth() {
      return (this.isDesktop) ? 485 : 520;
    }
  },
  methods: {
    formatNum(num) {
      if (Number(num) > 0) {
        return '+' + num;
      } else {
        return num;
      }
    },
    isMobile() {
      return document.documentElement.clientWidth <= 650;
    },
    getColor(val) {
      return 'color:#6D6D6D;';
    }
  },
}
</script>